import React, { useState, useEffect } from "react";
import { CheckCircle, XCircle } from "react-feather";
import { useParams, Link } from "react-router-dom";
import { useIntl } from "react-intl";
import logo from "../../assets/images/buscar-logo-light-2.png";
import { accountConfirmationRequest } from "../../api";
import "./styles.scss";

const ValidateEmail = () => {
  const { token } = useParams();
  const { formatMessage } = useIntl();
  const [result, setResult] = useState();
  const success = result && [200, 201].includes(result.status);

  useEffect(() => {
    accountConfirmationRequest(token)
      .then(res => setResult(res))
      .catch(err => setResult(err.response));
  }, [token]);

  return (
    <div className="validate-email">
      <div className="logo has-title">
        <img alt="BusCAR logo" src={logo} />
        <div className="auth-title">
          {formatMessage({ id: "validar-conta" })}
        </div>
      </div>
      {result ? (
        <>
          <div className="result-message">
            {success ? (
              <CheckCircle
                className="success-icon"
                size="32px"
                title={formatMessage({ id: "sucesso" })}
              />
            ) : (
              <XCircle
                className="error-icon"
                size="32px"
                title={formatMessage({ id: "erro" })}
              />
            )}
            <p>
              {result.data.message ||
                formatMessage({
                  id: success
                    ? "sucesso-validacao-email"
                    : "erro-validacao-email"
                })}
            </p>
          </div>
          <div className={`links${!success ? " failed" : ""}`}>
            {success && (
              <Link to="/login">{formatMessage({ id: "entrar" })}</Link>
            )}
          </div>
        </>
      ) : (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default ValidateEmail;
